import artifact from '../../fabric/DQArtifact.json';
import constants from './constants';

export const getWorkloadName = () => {
	const iframeURL = new URL(window.location.href);
	const workloadName = iframeURL.searchParams.get(constants.WORKLOAD_NAME_PARAM);
	return workloadName || import.meta.env.VITE_WORKLOAD_NAME;
};

export const getItemType = () => `${getWorkloadName()}.${artifact.name}`;
